import axios from 'axios';
import {
    PatientReceiptModel,
    PatientReceiptViewModel,
    PtStatementModel
} from '../models';
import {
    Statement,
    StatementResult,
    StatementListResult
} from '../models/statement';

export const getPatientReceiptViewsAsync = async (): Promise<PatientReceiptViewModel[]> => {
    const response = await axios.get('/api/statement/view');
    return response.data;
};

export const getPatientReceiptAsync = async (
    receiptId: string
): Promise<PatientReceiptModel> => {
    const response = await axios.get(`/api/statement/${receiptId}`);
    return response.data;
};

export const getCurrentStatementAsync = async (): Promise<Undefinable<PtStatementModel>> => {
    const response = await axios.get('/api/statement/current');
    return response.data;
};

export const getStatementsAsync = async (): Promise<StatementListResult> => {
    const response = await axios.get('/api/statement');
    return response.data;
};

export const getStatementAsync = async (id: string): Promise<StatementResult> => {
    const response = await axios.get(`/api/statement/${id}`);
    return response.data;
};

export const getCurrentStatement = async (): Promise<Undefinable<Statement>> => {
    const response = await axios.get(`/api/statement/current`);
    return response.data;
};
